import axiosInstance from '../utils/axiosInstance';

const ENDPOINTS = {
  position: '/api/fonction/list',
  department: 'api/departement/list',
  site: 'api/site/list',
  profile: '/api/profile/list',
  seniority: '/api/seniority/list',
  eventType: '/api/eventType/list',
  society: '/api/society/list',
  collaborateur: '/api/collaborateur/list',
  fonction: '/api/fonction/list',
  teams: '/api/teams/list',
  countries: '/api/settings/GetCountries',
};

const getPositions = async () => {
  const response = await axiosInstance.get(ENDPOINTS.position);
  return response.data;
};

const getDepartments = async (): Promise<ApiResponse<SelectItem[]>> => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.department,
  );
  return response.data;
};

const getSites = async (): Promise<ApiResponse<SelectItem[]>> => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.site,
  );
  return response.data;
};

const getEventTypes = async () => {
  const response = await axiosInstance.get(ENDPOINTS.eventType);
  return response.data;
};

const getSocieties = async (): Promise<ApiResponse<SelectItem[]>> => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.society,
  );
  return response.data;
};

const getCollaborateurs = async () => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.collaborateur,
  );
  return response.data;
};

const getFunctions = async (): Promise<ApiResponse<SelectItem[]>> => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.fonction,
  );
  return response.data;
};

const getTeams = async (): Promise<ApiResponse<SelectItem[]>> => {
  const response = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.teams,
  );
  return response.data;
};

const getRegimes = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    '/api/congee/listregime',
  );
  return data;
};

const GetTypeOfContractService = async (): Promise<SelectItem[]> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    '/api/collaborateur/GetTypeOfContract',
  );
  return data.data;
};

const getHtravailService = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } =
    await axiosInstance.get<ApiResponse<SelectItem[]>>('/api/Htravail/list');
  return data;
};

const GetDepartureReasonsService = async (): Promise<SelectItem[]> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    '/api/Contract/GetDepartureReasons',
  );
  return data.data;
};
const getCurrenciesService = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    '/api/settings/CurrencyList',
  );
  return data;
};
const getSuperiorService = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    '/api/collaborateur/UsersSelectItem',
  );
  return data;
};

const getAreaListBySite = async (
  siteId: number,
): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    `/api/area/listbysite/${siteId}`,
  );
  return data;
};

const getCountries = async (): Promise<ApiResponse<SelectItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    ENDPOINTS.countries,
  );
  return data;
};
// Export all functions
export {
  getPositions,
  getDepartments,
  getSites,
  getEventTypes,
  getSocieties,
  getCollaborateurs,
  getFunctions,
  getTeams,
  getRegimes,
  GetTypeOfContractService,
  getHtravailService,
  GetDepartureReasonsService,
  getCurrenciesService,
  getSuperiorService,
  getAreaListBySite,
  getCountries,
};
